
const isDateOnlyString = (value) =>
    typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);

const parseDateInput = (value) => {
    if (value instanceof Date) return new Date(value);
    if (isDateOnlyString(value)) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day);
    }
    return new Date(value);
};

const getMonthName = (date) => {
    const dateObj = parseDateInput(date);  // 2009-11-10
    const month = dateObj.toLocaleString('default', { month: 'short' });
    return month;
}

const getDayName = (date) => {
    const dateObj = parseDateInput(date);  // 2009-11-10
    const day = dateObj.toLocaleString('default', { day: 'numeric' });
    return day;
}

const getYear = (date) => {
    const dateObj = parseDateInput(date);  // 2009-11-10
    const day = dateObj.toLocaleString('default', { year: 'numeric' });
    return day;
}

const getTime = (date) => {
    const dateObj = parseDateInput(date); 
    var time = dateObj.toLocaleTimeString('en-US');
    return time;
}



const generateFullDate = (date) => {
    const day = getDayName(date);
    const month = getMonthName(date);
    const year = getYear(date);
    return `${day}-${month}-${year}`
}



export {
    getMonthName,
    getDayName,
    generateFullDate,
    getTime,
    parseDateInput
}
